/* eslint no-unused-vars: off */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { doGetUsers } from '../../../../../redux/actions/userActions';
import { allUsersSelector } from '../../../../../redux/selectors/userSelectors';
import InstitutionalSystemForm from './InstitutionalSystemForm';

class InstitutionalSystemFormContainer extends Component {
  componentDidMount() {
    const { users } = this.props;
    if (!users || users.length < 1) {
      this.props.onGetUsers();
    }
  }

  render() {
    const { users, ...rest } = this.props;

    return <InstitutionalSystemForm users={users} {...rest} />;
  }
}

InstitutionalSystemFormContainer.propTypes = {
  users: PropTypes.array,
  onGetUsers: PropTypes.func
};
InstitutionalSystemFormContainer.defaultProps = {
  users: [],
  onGetUsers: undefined
};

const mapStateToProps = (state, props) => ({
  users: allUsersSelector(state, props)
});

const mapDispatchToProps = dispatch => ({
  onGetUsers: () => dispatch(doGetUsers())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstitutionalSystemFormContainer);
export { InstitutionalSystemFormContainer };
